import { getApi } from '../api/storeFront';
import { parseStoreProduct } from '../utils';
const getProducts = async ({ id, count, cursor }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('count', count.toString());
    urlParams.append('cursor', cursor.toString());
    const response = await getApi(`/${id}/products?${urlParams.toString()}`, logger);
    const products = response?.data;
    return {
        data: [...parseStoreProduct(products)],
        collectionName: response?.collectionName,
        paginate() {
            return !!response.hasNextPage && getProducts({ id, count, cursor: response?.cursor }, logger);
        },
    };
};
export default getProducts;
